import * as React from "react";
import SelectableCard from "./SelectableCard/SelectableCard";
import {ISelectableCard} from "./SelectableCard/ISelectableCard";

interface IProps {
    cardsValues: ISelectableCard[];
}

export default class CardsSelect  extends React.Component<
    IProps
    > {

    public renderSelectableCards = () => {
        return this.props.cardsValues.map((cardValue, index)=> {
            return <SelectableCard data={cardValue} key={index}/>
        });
    };

    public render() {
        return (
            <>
            {this.renderSelectableCards()}
            </>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/CardsSelect/CardsSelect.tsx